import React from 'react'

import { createValidIcon } from '@ui/icons/utils/type-helper'

import styles from './Card.module.scss'

export const JCBCard = createValidIcon(() => {
  return (
    <svg
      className={styles.cardShadow}
      width='36'
      height='24'
      viewBox='0 0 36 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 4C0 1.79086 1.79086 0 4 0H32.0002C34.2093 0 36.0002 1.79086 36.0002 4V20C36.0002 22.2091 34.2093 24 32.0002 24H4.00001C1.79087 24 0 22.2091 0 20V4Z'
        fill='white'
      />
      <path
        d='M24.0784 13.9363H25.8103C25.8598 13.9363 25.9753 13.9197 26.0248 13.9197C26.3547 13.8535 26.6351 13.5557 26.6351 13.142C26.6351 12.7448 26.3547 12.4469 26.0248 12.3642C25.9753 12.3477 25.8763 12.3477 25.8103 12.3477H24.0784V13.9363Z'
        fill='url(#paint0_linear_8607_5698)'
      />
      <path
        d='M25.6125 2.96484C23.9631 2.96484 22.6105 4.30524 22.6105 5.97659V9.10417H26.8497C26.9486 9.10417 27.0641 9.10417 27.1466 9.12072C28.1033 9.17036 28.8125 9.66681 28.8125 10.5273C28.8125 11.2058 28.3342 11.785 27.4435 11.9008V11.9339C28.4167 12.0001 29.1589 12.5462 29.1589 13.3901C29.1589 14.3003 28.3342 14.896 27.2455 14.896H22.594V21.0188H26.9981C28.6476 21.0188 30.0002 19.6784 30.0002 18.007V2.96484H25.6125Z'
        fill='url(#paint1_linear_8607_5698)'
      />
      <path
        d='M26.4206 10.7262C26.4206 10.329 26.1402 10.0642 25.8103 10.0146C25.7773 10.0146 25.6949 9.99805 25.6454 9.99805H24.0784V11.4543H25.6454C25.6949 11.4543 25.7938 11.4543 25.8103 11.4377C26.1402 11.3881 26.4206 11.1233 26.4206 10.7262Z'
        fill='url(#paint2_linear_8607_5698)'
      />
      <path
        d='M9.01855 2.96484C7.36907 2.96484 6.01649 4.30524 6.01649 5.97659V13.4067C6.85773 13.8204 7.73196 14.0851 8.60618 14.0851C9.64536 14.0851 10.2062 13.4563 10.2062 12.5958V9.08762H12.7794V12.5793C12.7794 13.9362 11.9381 15.0449 9.08453 15.0449C7.35258 15.0449 6 14.6643 6 14.6643V21.0022H10.4041C12.0536 21.0022 13.4062 19.6618 13.4062 17.9905V2.96484H9.01855Z'
        fill='url(#paint3_linear_8607_5698)'
      />
      <path
        d='M17.3155 2.96484C15.6661 2.96484 14.3135 4.30524 14.3135 5.97659V9.91503C15.0722 9.26965 16.3918 8.85595 18.5197 8.95524C19.6578 9.00488 20.8784 9.31929 20.8784 9.31929V10.5935C20.2681 10.2791 19.5423 9.99777 18.6021 9.93157C16.9856 9.81574 16.0124 10.61 16.0124 12.0001C16.0124 13.4067 16.9856 14.201 18.6021 14.0686C19.5423 14.0024 20.2681 13.7045 20.8784 13.4067V14.6809C20.8784 14.6809 19.6743 14.9953 18.5197 15.0449C16.3918 15.1442 15.0722 14.7305 14.3135 14.0851V21.0353H18.7176C20.3671 21.0353 21.7197 19.6949 21.7197 18.0236V2.96484H17.3155Z'
        fill='url(#paint4_linear_8607_5698)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_8607_5698'
          x1='22.6076'
          y1='13.1439'
          x2='30.0199'
          y2='13.1439'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#007940' />
          <stop offset='0.2285' stopColor='#00873F' />
          <stop offset='0.7433' stopColor='#40A737' />
          <stop offset='1' stopColor='#5CB531' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_8607_5698'
          x1='22.6075'
          y1='11.9846'
          x2='30.0204'
          y2='11.9846'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#007940' />
          <stop offset='0.2285' stopColor='#00873F' />
          <stop offset='0.7433' stopColor='#40A737' />
          <stop offset='1' stopColor='#5CB531' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_8607_5698'
          x1='22.6074'
          y1='10.7241'
          x2='30.02'
          y2='10.7241'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#007940' />
          <stop offset='0.2285' stopColor='#00873F' />
          <stop offset='0.7433' stopColor='#40A737' />
          <stop offset='1' stopColor='#5CB531' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_8607_5698'
          x1='6.013'
          y1='11.9846'
          x2='13.5401'
          y2='11.9846'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#1F286F' />
          <stop offset='0.4751' stopColor='#004E94' />
          <stop offset='0.8261' stopColor='#0066B1' />
          <stop offset='1' stopColor='#006FBC' />
        </linearGradient>
        <linearGradient
          id='paint4_linear_8607_5698'
          x1='14.2708'
          y1='11.9846'
          x2='21.5814'
          y2='11.9846'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#6C2C2F' />
          <stop offset='0.1735' stopColor='#882730' />
          <stop offset='0.5731' stopColor='#BE1833' />
          <stop offset='0.8585' stopColor='#DC0436' />
          <stop offset='1' stopColor='#E60039' />
        </linearGradient>
      </defs>
    </svg>
  )
})
